import StorageService from './StorageService';

const WebSocketService = {
	Protocol: 'wss',
	Port: '8678',
	Socket: null,
	SymbolsCoding: [
		{ target: /\//g, replacement: '%2F' },
		{ target: /\+/g, replacement: '%2B' },
	],
	MessageEvents: {
		Heartbeat: (type = '', data = {}, callback = () => {}) => {
			console.log('Heartbeat message:', type, data);
		},
		LoggedMsg: (type = '', data = {}, callback = () => {}) => {
			console.log('The user logged successful:', type, data);
			// TelegramWebApiService.ShowAlert('The user logged successful');
		},
		Default: (type = '', data = {}, callback = () => {}) => {
			console.log(`There is no any handler for the message with type ${type}`, data);
		},
		MobileTransactionUpdatedMsg: (type = '', data = {}, callback = () => {}) => {
			if (data?.msg?.transactionStatus === 2) {
				StorageService.UpdateCurrencies();
				StorageService.UpdateBillingBalance();
			}
		},
	},
	CustomHandlers: [],
	AddCustomHandler: handler => {
		WebSocketService.CustomHandlers.push(handler);
	},
	RemoveCustomeHandler: handlerName => {
		WebSocketService.CustomHandlers = WebSocketService.CustomHandlers.filter(item => {
			return item.name !== handlerName;
		});
	},
	SetSymbolsCoding: token => {
		return WebSocketService.SymbolsCoding.reduce((acc, code) => acc?.replace(code?.target, code?.replacement), token);
	},
	Connect: (url, reconnectTimeout = 2000) => {
		if (WebSocketService.Socket) return;
		WebSocketService.URL = url;
		WebSocketService.ReconnectTimeout = reconnectTimeout;
		WebSocketService.Socket = new WebSocket(WebSocketService.URL);

		WebSocketService.Socket.onopen = () => {
			console.log('Connected to server');
		};

		WebSocketService.Socket.onmessage = event => {
			try {
				const dataObject = JSON?.parse(event?.data);
				const messageType = dataObject?.type;
				const messageEvent = WebSocketService?.MessageEvents[messageType] || WebSocketService?.MessageEvents?.Default;

				messageEvent(messageType, dataObject);

				WebSocketService.CustomHandlers.forEach(handler => handler(dataObject));
			} catch (err) {
				console.error(err);
			}
		};

		WebSocketService.Socket.onclose = () => {
			console.log('Connection closed, reconnecting...');
			WebSocketService.Socket = null;
			setTimeout(
				() => WebSocketService.Connect(WebSocketService.URL, WebSocketService.ReconnectTimeout),
				WebSocketService.ReconnectTimeout
			);
		};

		WebSocketService.Socket.onerror = error => {
			console.error('WebSocket error:', error);
			WebSocketService.Socket.close();
			WebSocketService.Socket = null;
		};
	},
	Send: (data = {}) => {
		if (WebSocketService?.Socket?.readyState === WebSocket?.OPEN) {
			try {
				const dataString = JSON?.stringify(data);
				WebSocketService?.Socket?.send(dataString);
			} catch (err) {
				console.error(err);
			}
		} else {
			console.warn('Socket not open. Message not sent.');
		}
	},
	DoConnection: (url, token) => {
		if (!url || !token) {
			console.error('Unable to do connection', url, token);
			return;
		}
		const wsURL = new URL(url);
		const codingToken = WebSocketService.SetSymbolsCoding(token);
		const wsEndpoint = `${WebSocketService.Protocol}://${wsURL?.hostname}:${WebSocketService.Port}?Token=${codingToken}`;
		console.info('Connect to the server here: ', wsEndpoint);
		WebSocketService.Connect(wsEndpoint, 2000);
	},
};

export default WebSocketService;
